export default __webpack_public_path__ + "static/compareItemImg4-a80a9d08cdb70733637f0353b578c36f.webp";